import { createSelector } from 'reselect';
import _ from 'lodash';
import dayjs from 'dayjs';
import { formValueSelector } from 'redux-form';
import { isEmpty } from 'utils/validation';
import { getCustomTenderFirmName } from 'utils/other';

const cardPointer = state => state.tenderCard;
const regionPointer = state => state.dictionary.region;
const currencyPointer = state => state.dictionary.currency;
const placingWayPointer = state => state.dictionary.placingWay;
const fvselector = formValueSelector('cardHistoryFilter');
const isCreateViewPointer = state => fvselector(state, 'isCreateView');
const isOwnerViewPointer = state => fvselector(state, 'isOwnerView');
const isStatusViewPointer = state => fvselector(state, 'isStatusView');
const isCommentViewPointer = state => fvselector(state, 'isCommentView');
const isDocumentViewPointer = state => fvselector(state, 'isDocumentView');
const isSourceLostViewPointer = state => fvselector(state, 'isSourceLostView');
const isEditViewPointer = state => fvselector(state, 'isEditView');
const userDependencyPointer = state => state.dictionary.userDependency;
const logTypePointer = state => state.dictionary.logType;

export default createSelector(
  [
    cardPointer,
    regionPointer,
    currencyPointer,
    placingWayPointer,
    isCreateViewPointer,
    isOwnerViewPointer,
    isStatusViewPointer,
    isCommentViewPointer,
    isDocumentViewPointer,
    isSourceLostViewPointer,
    isEditViewPointer,
    userDependencyPointer,
    logTypePointer,
  ],
  (
    tenderCard,
    region,
    currency,
    placingWay,
    isCreateView,
    isOwnerView,
    isStatusView,
    isCommentView,
    isDocumentView,
    isSourceLostView,
    isEditView,
    userDependency,
    logType,
  ) => {
    const switchers = {
      create: 0,
      owner: 0,
      status: 0,
      comment: 0,
      document: 0,
      edit: 0,
    };
    const historyFilter = [];
    if (isCreateView || isCreateView === undefined) {
      historyFilter.push(1);
    }
    if (isOwnerView || isCreateView === undefined) {
      historyFilter.push(2);
    }
    if (isStatusView || isCreateView === undefined) {
      historyFilter.push(3);
    }
    if (isCommentView || isCreateView === undefined) {
      historyFilter.push(4);
    }
    if (isDocumentView || isCreateView === undefined) {
      historyFilter.push(5);
      historyFilter.push(6);
    }
    if (isEditView || isCreateView === undefined) {
      historyFilter.push(9);
      historyFilter.push(13);
    }
    if (isSourceLostView || isSourceLostView === undefined) {
      historyFilter.push(14);
    }

    const tenderHistory =
      tenderCard.history && tenderCard.history.length > 0
        ? tenderCard.history
            .map(val => {
              const x = _.cloneDeep(val);

              // PRODOC-974
              x.changes = x.changes || {
                data: [],
                customers: [],
                organizer: [],
              };

              switch (x.actionId) {
                case 1:
                  switchers.create += 1;
                  break;
                case 2:
                  switchers.owner += 1;
                  break;
                case 3:
                  switchers.status += 1;
                  break;
                case 4:
                  switchers.comment += 1;
                  break;
                case 5:
                case 6:
                  switchers.document += 1;
                  break;
                case 14:
                  switchers.sourceLost += 1;
                  break;
                case 9:
                case 13: {
                  const logs = {
                    data: [],
                    customers: [],
                    organizer: [],
                  };
                  const priceMap = {
                    changed: false,
                    price: {},
                    currency: {},
                  };

                  x.changes.data.forEach(el => {
                    switch (el.typeId) {
                      case 4: {
                        const fomatter = new Intl.NumberFormat('ru-RU', {
                          maximumFractionDigits: 2,
                        });
                        priceMap.changed = true;
                        if (!isEmpty(el.newValue)) {
                          priceMap.price.newValue = fomatter.format(el.newValue);
                        }
                        if (!isEmpty(el.prevValue)) {
                          priceMap.price.prevValue = fomatter.format(el.prevValue);
                        }
                        if (!isEmpty(el.additional)) {
                          const curr = currency.find(e => e.id === +el.additional);
                          if (curr) {
                            priceMap.currency.additional = curr.name;
                          }
                        }
                        priceMap.order = el.order;
                        break;
                      }
                      case 5: {
                        priceMap.changed = true;
                        const prevValue = currency.find(e => e.id === +el.prevValue);
                        const newValue = currency.find(e => e.id === +el.newValue);
                        if (prevValue) {
                          priceMap.currency.prevValue = prevValue.name;
                        }
                        if (newValue) {
                          priceMap.currency.newValue = newValue.name;
                        }
                        if (!isEmpty(el.additional)) {
                          const fomatter = new Intl.NumberFormat('ru-RU', {
                            maximumFractionDigits: 2,
                          });
                          priceMap.price.additional = fomatter.format(el.additional);
                        }
                        priceMap.order = el.order;
                        break;
                      }
                      case 6:
                      case 7:
                      case 8:
                        if (el.prevValue) {
                          el.prevValue = dayjs.utc(el.prevValue).format('DD.MM.YYYY HH:mm:ss');
                        }
                        if (el.newValue) {
                          el.newValue = dayjs.utc(el.newValue).format('DD.MM.YYYY HH:mm:ss');
                        }
                        logs.data.push(el);
                        break;
                      case 2: {
                        const prevValue = placingWay.find(e => e.id === +el.prevValue);
                        const newValue = placingWay.find(e => e.id === +el.newValue);
                        if (prevValue) {
                          el.prevValue = prevValue.name;
                        }
                        if (newValue) {
                          el.newValue = newValue.name;
                        }
                        logs.data.push(el);
                        break;
                      }
                      case 18:
                      case 20:
                        {
                          const regionData = region.find(e => +e.code === +el.regionCode);
                          el.regionName = regionData ? regionData.name : 'Не указан';
                          logs.data.push(el);
                        }
                        break;
                      case 21:
                      case 22: {
                        const fomatter = new Intl.NumberFormat('ru-RU', {
                          maximumFractionDigits: 2,
                        });
                        if (!isEmpty(el.newValue)) {
                          el.newValue = fomatter.format(el.newValue);
                        }
                        if (!isEmpty(el.prevValue)) {
                          el.prevValue = fomatter.format(el.prevValue);
                        }
                        logs.data.push(el);
                        break;
                      }
                      default:
                        logs.data.push(el);
                        break;
                    }
                  });

                  // Собираем цену
                  if (priceMap.changed) {
                    logs.data.push({
                      typeName: 'Цена тендера',
                      prevValue: priceMap.price.prevValue,
                      newValue: priceMap.price.newValue,
                      prevCode: priceMap.currency.prevValue,
                      newCode: priceMap.currency.newValue,
                      value: priceMap.price.additional,
                      code: priceMap.currency.additional,
                      order: priceMap.order,
                      typeId: 4,
                    });
                  }

                  const customersMap = {};
                  x.changes.customers.forEach(el => {
                    if (x.actionId === 13 && !customersMap[el.firmId]) {
                      customersMap[el.firmId] = {};
                      customersMap[el.firmId].order = el.order;
                    }

                    if (el.typeId === 19) {
                      customersMap[el.firmId].prevName = el.prevValue;
                      customersMap[el.firmId].newName = el.newValue;
                      const regionData = region.find(e => +e.id === +el.additional);
                      customersMap[el.firmId].region = `(${regionData.code}. ${regionData.name})`;
                    }

                    if (el.typeId === 10) {
                      if (x.actionId === 9) {
                        logs.customers.push({
                          newValue: getCustomTenderFirmName(el, region),
                          order: el.order,
                        });
                      } else {
                        customersMap[el.firmId].newName = el.newValue;
                        const regionData = region.find(e => +e.id === +el.additional);
                        customersMap[el.firmId].newRegion = `(${regionData.code}. ${regionData.name})`;
                      }
                    }

                    if (el.typeId === 11) {
                      // Для ручные тендеров
                      if (x.actionId === 9) {
                        logs.customers.push({
                          prevValue: getCustomTenderFirmName(el, region),
                          order: el.order,
                        });
                      } else {
                        customersMap[el.firmId].prevName = el.prevValue;
                        const regionData = region.find(e => +e.id === +el.additional);
                        customersMap[el.firmId].prevRegion = `(${regionData.code}. ${regionData.name})`;
                      }
                    }

                    if (el.typeId === 20) {
                      if (!customersMap[el.firmId]) {
                        customersMap[el.firmId] = {};
                      }
                      const prevRegionData = region.find(e => +e.id === +el.prevValue);
                      let prevRegion = '';
                      if (prevRegionData) {
                        prevRegion = `(${prevRegionData.code}. ${prevRegionData.name})`;
                      }
                      const newRegionData = region.find(e => +e.id === +el.newValue);
                      let newRegion = '';
                      if (newRegionData) {
                        newRegion = `(${newRegionData.code}. ${newRegionData.name})`;
                      }
                      customersMap[el.firmId].prevRegion = prevRegion;
                      customersMap[el.firmId].newRegion = newRegion;
                      customersMap[el.firmId].name = el.additional;
                    }
                  });

                  Object.keys(customersMap).forEach(key => {
                    logs.customers.push({
                      prevValue: customersMap[key].prevName,
                      newValue: customersMap[key].newName,
                      prevCode: customersMap[key].prevRegion,
                      newCode: customersMap[key].newRegion,
                      code: customersMap[key].region,
                      value: customersMap[key].name,
                      order: customersMap[key].order,
                    });
                  });

                  const organizerMap = {};
                  x.changes.organizer.forEach(el => {
                    organizerMap.order = el.order;
                    if (el.typeId === 17) {
                      organizerMap.changed = true;
                      organizerMap.prevName = el.prevValue;
                      organizerMap.newName = el.newValue;
                      const regionData = region.find(e => +e.id === +el.additional);
                      organizerMap.region = `(${regionData.code}. ${regionData.name})`;
                    }

                    if (el.typeId === 12) {
                      if (x.actionId === 9) {
                        logs.organizer.push({
                          prevValue: getCustomTenderFirmName(el, region),
                          order: el.order,
                        });
                      } else {
                        organizerMap.changed = true;
                        organizerMap.prevName = el.prevValue;
                        const regionData = region.find(e => +e.id === +el.additional);
                        organizerMap.prevRegion = `(${regionData.code}. ${regionData.name})`;
                      }
                    }

                    if (el.typeId === 13) {
                      if (x.actionId === 9) {
                        logs.organizer.push({
                          newValue: getCustomTenderFirmName(el, region),
                          order: el.order,
                        });
                      } else {
                        organizerMap.changed = true;
                        organizerMap.newName = el.newValue;
                        const regionData = region.find(e => +e.id === +el.additional);
                        organizerMap.newRegion = `(${regionData.code}. ${regionData.name})`;
                      }
                    }

                    if (el.typeId === 18) {
                      organizerMap.changed = true;
                      const prevRegionData = region.find(e => +e.id === +el.prevValue);
                      let prevRegion = '';
                      if (prevRegionData) {
                        prevRegion = `(${prevRegionData.code}. ${prevRegionData.name})`;
                      }
                      const newRegionData = region.find(e => +e.id === +el.newValue);
                      let newRegion = '';
                      if (newRegionData) {
                        newRegion = `(${newRegionData.code}. ${newRegionData.name})`;
                      }
                      organizerMap.prevRegion = prevRegion;
                      organizerMap.newRegion = newRegion;
                      organizerMap.name = el.additional;
                    }
                  });

                  // Собираем организатора
                  if (organizerMap.changed) {
                    logs.organizer.push({
                      prevValue: organizerMap.prevName,
                      newValue: organizerMap.newName,
                      prevCode: organizerMap.prevRegion,
                      newCode: organizerMap.newRegion,
                      code: organizerMap.region,
                      value: organizerMap.name,
                      order: organizerMap.order,
                    });
                  }

                  switchers.edit += 1;

                  logs.data = _.sortBy(logs.data, ['order']);
                  x.changes = logs;
                  break;
                }
                default:
                  break;
              }
              x.actionName = logType.find(w => w.id === x.actionId).alias;
              return x;
            })
            .filter(e => historyFilter.indexOf(e.actionId) !== -1)
        : null;
    return {
      switchers,
      history: tenderHistory,
    };
  },
);
